import { render, staticRenderFns } from "./tongGuanFangShi.vue?vue&type=template&id=6001ef9c&scoped=true&"
import script from "./tongGuanFangShi.vue?vue&type=script&lang=js&"
export * from "./tongGuanFangShi.vue?vue&type=script&lang=js&"
import style0 from "./tongGuanFangShi.vue?vue&type=style&index=0&id=6001ef9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6001ef9c",
  null
  
)

export default component.exports